var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIcondevicessquareheimanTempsensorsolid = function SvgIcondevicessquareheimanTempsensorsolid(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Devices/icon.devices.square.heiman_tempsensor.solid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Devices/icon.devices.square.heiman_tempsensor.solid",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7785476,0.5 C53.062178,0.5 64.6726566,1.73607652 72.0726496,9.09532645 C79.1324104,16.1162174 79.4819285,25.8483637 79.4991166,38.215369 L79.4999529,39.4011429 L79.5,40 C79.5,53.2354694 77.9575853,63.1561151 72.0462934,70.0228751 C66.1401115,76.8836992 53.0349625,79.5 39.7687957,79.5 C26.4914909,79.5 13.9293322,76.125021 8.07881164,70.0036159 C2.2289156,63.8828643 0.5,54.1644504 0.5,40 C0.5,25.8190418 1.72065177,16.3480061 8.09351701,9.07019053 C14.3666554,1.90626305 26.169523,0.540252554 39.2038574,0.500861056 Z",
    id: "Rectangle",
    stroke: "#666666",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Center",
    stroke: "#979797",
    strokeWidth: 0.5,
    cx: 39.75,
    cy: 39.75,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5469495,10.9439819 L41.9403695,10.9447545 C42.6372368,10.9458054 43.344044,10.9486933 44.0568987,10.9566182 L44.9149782,10.9687505 C52.2290932,11.0959072 60.0104238,11.8802743 64.1285579,16.7176562 C69.0435602,22.4910822 69.1999996,29.4168526 69.206494,38.8276422 L69.2060303,41.4613914 C69.1931138,50.7848371 68.9764681,59.016799 64.1426549,63.8227124 C59.2190207,68.7179283 49.1057877,68.8729337 40.7253556,68.8801679 L39.3902507,68.8800536 C30.9164258,68.864185 20.2986632,68.3576663 15.9687436,63.8272674 C11.5626289,59.2171455 10.816903,50.5836997 10.816903,39.9124804 C10.816903,29.2355389 11.1788159,21.6431929 15.9760963,16.1646961 C20.3726262,11.1438565 29.6279569,10.9486028 37.6801259,10.9438205 L38.5469495,10.9439819 Z",
    id: "Rectangle",
    stroke: "#666666",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Holes",
    transform: "translate(21.5162, 21.4506)",
    fill: "#303030"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer-1",
    transform: "translate(8.8973, 8.8083)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8.66916,
    cy: 0.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.0048501,
    cy: 0.575526612,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.3405401,
    cy: 1.32476338,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15.3208149,
    cy: 2.57416808,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    cx: 16.9603962,
    cy: 4.34348926,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    cx: 18.1075397,
    cy: 6.45116541,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    cx: 18.6075397,
    cy: 8.83469175,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    cx: 18.3992435,
    cy: 11.2182181,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5",
    cx: 17.7033463,
    cy: 13.4407521,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-6",
    cx: 16.4067441,
    cy: 15.4645039,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-7",
    cx: 14.6652206,
    cy: 17.0303656,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-8",
    cx: 12.5078489,
    cy: 18.1676763,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-9",
    cx: 10.4028834,
    cy: 18.5945265,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-10",
    cx: 7.98539398,
    cy: 18.4126993,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-11",
    cx: 5.70030204,
    cy: 17.769474,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-12",
    cx: 3.7009994,
    cy: 16.4785589,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-13",
    cx: 2.09825134,
    cy: 14.7335806,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-14",
    cx: 1,
    cy: 12.6182059,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-15",
    cx: 0.5,
    cy: 10.3196306,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-16",
    cx: 0.614911245,
    cy: 7.90999787,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-17",
    cx: 1.3136627,
    cy: 5.66839654,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-18",
    cx: 2.63974022,
    cy: 3.6255689,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-19",
    cx: 4.41832455,
    cy: 2.08184318,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-20",
    cx: 6.57549414,
    cy: 1,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer-2",
    transform: "translate(6.781, 6.8157)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-21",
    cx: 9.53910069,
    cy: 0.618129657,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-21",
    cx: 6.75622536,
    cy: 1.49261304,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-21",
    cx: 4.37956828,
    cy: 3.10617889,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-21",
    cx: 2.4400031,
    cy: 5.25340761,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-21",
    cx: 1.09163526,
    cy: 7.7992347,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-21",
    cx: 0.5,
    cy: 10.5911751,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-21",
    cx: 0.653711965,
    cy: 13.4509936,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-21",
    cx: 1.5,
    cy: 16.242934,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-21",
    cx: 3.06023545,
    cy: 18.6716164,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-21",
    cx: 5.21127411,
    cy: 20.5871396,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-21",
    cx: 7.71260813,
    cy: 21.9059927,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-21",
    cx: 10.5714633,
    cy: 22.5891978,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-21",
    cx: 13.689657,
    cy: 22.5228523,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-21",
    cx: 16.4556284,
    cy: 21.5228523,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-21",
    cx: 18.9178559,
    cy: 20.0070311,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-21",
    cx: 20.8007537,
    cy: 17.90377,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-21",
    cx: 22.1114163,
    cy: 15.2909405,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-21",
    cx: 22.7238967,
    cy: 12.4579229,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-21",
    cx: 22.5901541,
    cy: 9.58019323,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-21",
    cx: 21.7238967,
    cy: 6.85100737,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-21",
    cx: 20.1840008,
    cy: 4.43940396,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-21",
    cx: 18.0754846,
    cy: 2.49261304,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-21",
    cx: 15.5113522,
    cy: 1.11812966,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-21",
    cx: 12.7284769,
    cy: 0.5,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer-3",
    transform: "translate(4.7855, 4.8647)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-22",
    cx: 13.6982688,
    cy: 0.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-23",
    cx: 16.958963,
    cy: 0.891810559,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-24",
    cx: 20.1091251,
    cy: 2.18513136,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-25",
    cx: 22.8132179,
    cy: 4.27963404,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-26",
    cx: 24.8528049,
    cy: 6.95872139,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-27",
    cx: 26.2433011,
    cy: 10.1658574,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-28",
    cx: 26.667737,
    cy: 13.5171581,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-29",
    cx: 26.2433011,
    cy: 16.8684587,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-30",
    cx: 24.8971228,
    cy: 20.0330285,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-31",
    cx: 22.7848842,
    cy: 22.7276184,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-32",
    cx: 20.0817995,
    cy: 24.7810638,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-33",
    cx: 16.9392035,
    cy: 26.0931233,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-34",
    cx: 13.5176778,
    cy: 26.5176398,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-35",
    cx: 10.2227859,
    cy: 26.0931233,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-36",
    cx: 7.08099497,
    cy: 24.7766358,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-37",
    cx: 4.34859157,
    cy: 22.6799169,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-38",
    cx: 2.21215496,
    cy: 20.0050102,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-39",
    cx: 0.934613628,
    cy: 16.8388654,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-40",
    cx: 0.5,
    cy: 13.4415595,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-41",
    cx: 0.92954828,
    cy: 10.0957457,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-42",
    cx: 2.25734055,
    cy: 6.96076449,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-43",
    cx: 4.36348571,
    cy: 4.26123554,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-44",
    cx: 7.0461078,
    cy: 2.16247036,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-45",
    cx: 10.2385187,
    cy: 0.876743966,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer-4",
    transform: "translate(3.1781, 3.0766)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-46",
    cx: 17.4799438,
    cy: 0.604557313,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-47",
    cx: 21.1819855,
    cy: 1.70464859,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-48",
    cx: 24.4721238,
    cy: 3.68927743,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-49",
    cx: 27.1817074,
    cy: 6.43476614,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-50",
    cx: 29.0487317,
    cy: 9.75063305,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-51",
    cx: 29.990266,
    cy: 13.5163601,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-52",
    cx: 29.990266,
    cy: 17.3275122,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-53",
    cx: 28.990266,
    cy: 21.0639407,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-54",
    cx: 26.9480023,
    cy: 24.3674629,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-55",
    cx: 24.2287799,
    cy: 27.0533412,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-56",
    cx: 20.9062507,
    cy: 28.9548552,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-57",
    cx: 16.8081235,
    cy: 29.9548552,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-58",
    cx: 12.9798362,
    cy: 29.8672927,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-59",
    cx: 9.27210377,
    cy: 28.8672927,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-60",
    cx: 5.95254459,
    cy: 26.8586594,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-61",
    cx: 3.27540225,
    cy: 24.1279348,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-62",
    cx: 1.42777436,
    cy: 20.7178813,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-63",
    cx: 0.5,
    cy: 17.052031,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-64",
    cx: 0.5,
    cy: 13.212181,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-65",
    cx: 1.5,
    cy: 9.48565599,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-66",
    cx: 3.49222215,
    cy: 6.11582791,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-67",
    cx: 6.18965842,
    cy: 3.49987798,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-68",
    cx: 9.54530146,
    cy: 1.56931418,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-69",
    cx: 13.6209131,
    cy: 0.5,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer-5",
    transform: "translate(1.5165, 1.4571)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-70",
    cx: 21.7939508,
    cy: 1.25909476,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-71",
    cx: 25.7295221,
    cy: 3.05832792,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-72",
    cx: 28.9934585,
    cy: 5.81919745,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-73",
    cx: 31.4545605,
    cy: 9.40730097,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-74",
    cx: 32.9275853,
    cy: 13.4773375,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-75",
    cx: 33.2718186,
    cy: 17.722097,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-76",
    cx: 32.5239699,
    cy: 22.0375748,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-77",
    cx: 30.6611783,
    cy: 25.8380843,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-78",
    cx: 27.8168725,
    cy: 29.1502862,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-79",
    cx: 24.2486153,
    cy: 31.5161446,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-80",
    cx: 20.1654526,
    cy: 32.9328021,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-81",
    cx: 16.3021697,
    cy: 33.2580056,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-82",
    cx: 11.9982166,
    cy: 32.5291554,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-83",
    cx: 8.12896716,
    cy: 30.6835094,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-84",
    cx: 4.78332174,
    cy: 27.9596948,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-85",
    cx: 2.29738042,
    cy: 24.3691733,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-86",
    cx: 0.824732444,
    cy: 20.3195169,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-87",
    cx: 0.5,
    cy: 16.0512684,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-88",
    cx: 1.27956512,
    cy: 11.8240628,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-89",
    cx: 3.15246836,
    cy: 7.89593381,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-90",
    cx: 5.95064396,
    cy: 4.63372462,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-91",
    cx: 9.55608162,
    cy: 2.26755214,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-92",
    cx: 13.6749489,
    cy: 0.845650479,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-70",
    cx: 17.4672368,
    cy: 0.5,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer-6"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-93",
    cx: 21.5235912,
    cy: 0.71471186,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-94",
    cx: 26.0579227,
    cy: 2.1792749,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-95",
    cx: 30.0426,
    cy: 4.7611952,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-96",
    cx: 33.1881491,
    cy: 8.26458383,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-97",
    cx: 35.34802,
    cy: 12.475829,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-98",
    cx: 36.2376279,
    cy: 17.156629,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-99",
    cx: 35.9852702,
    cy: 21.8184024,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-100",
    cx: 34.4148994,
    cy: 26.2824127,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-101",
    cx: 31.7446091,
    cy: 30.2282626,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-102",
    cx: 28.5141123,
    cy: 33.0776153,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-103",
    cx: 24.443754,
    cy: 35.1220633,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-104",
    cx: 19.8844882,
    cy: 36.1220633,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-105",
    cx: 15.1712166,
    cy: 35.9269485,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-106",
    cx: 10.6833313,
    cy: 34.4527703,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-107",
    cx: 6.70232079,
    cy: 31.9118774,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-108",
    cx: 3.52800761,
    cy: 28.3702318,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-109",
    cx: 1.39991567,
    cy: 24.1851432,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-110",
    cx: 0.5,
    cy: 19.5197438,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-111",
    cx: 0.776273458,
    cy: 14.7889937,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-112",
    cx: 2.29913871,
    cy: 10.3076679,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-113",
    cx: 4.99697082,
    cy: 6.39954537,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-114",
    cx: 8.18069546,
    cy: 3.5705231,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-115",
    cx: 12.3092338,
    cy: 1.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-116",
    cx: 16.8612882,
    cy: 0.5,
    r: 1
  }))))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIcondevicessquareheimanTempsensorsolid);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.devices.square.heiman_tempsensor.solid.e834252add7d2ef9090d023219b2db80.svg";